<template>
  <div class='tour'>
    <!-- <img src='@/assets/nmLogoTekst2.png'> --><br />
    <h1 class='daytour'>Old towns of the south</h1>
    <!-- <div class='tourPic'>
      <img src='@/assets/placestogo/04/01.jpg'>
    </div> -->
    <div
      style='
        margin: 0 auto;
        margin-top: 30px;
        margin-bottom: 30px;
        padding: 10px 5vw;
      '
    >
      <vue-picture-swipe :items='items'></vue-picture-swipe>
    </div>

    <div>
      <ul class='fa-ul'>
        <li>
          <!-- <span class='fa-li'><i class='fas fa-tree fa-2x'></i></span>  -->
          <!-- <span class='fa-li'><img  src='@/assets/logo/lovcen-green.png'/></span>
      <a data-toggle='collapse' href='#tourDescription'><h4 class='titles'>Tour description</h4></a> -->
          <div class='' id=''>
            <p class='pasus'>
              Towns of Bar and Ulcinj are situated far in the south of
              Montenegro and are the sunniest in the country. They are known for
              their olive groves, southern fruits plantations, long beaches,
              multicultural heritage and harmonious coexistence of different
              ethnic groups and religions.
            </p>
            <p class='pasus'>
              Whilst beaches in Bar are pebbly, sandy or rocky, the longest
              sandy beach on Adriatic coast belongs to Ulcinj as well as a river
              island known for its summer resort for nudists.
            </p>
            <p class='pasus'>
              The greatest attractions are without doubt old towns of Ulcinj and
              Bar whose foundations date back to distant past and the time when
              this region was dominated by Illyrians. Today they are cultural
              highlights known for their multicultural contents, Venetian walls,
              architecture, churches and mosques, museums…
            </p>
            <p class='pasus'>
              Old town of Bar has a unique position – in the immediate vicinity
              of the mountainous hinterland, hardly accessible yet only 4 km
              away from the sea shore. It melts with steep cliffs of Rumija
              Mountain and it’s surrounded by olive groves and oriental heritage
              environment.
            </p>
            <p class='pasus'>
              Old town of Ulcinj is situated on the cliff as well and it’s
              surrounded by ramparts the oldest of which originates from
              Illyrian period a few centuries BC.
            </p>
            <p class='pasus'>
              A number of civilizations had left their traces in this area:
              Illyrians, Romans, Byzantines, medieval Serbian and Montenegrin
              rulers, Venetians and Ottomans.
            </p>
            <p class='pasus'>
              Old stories tell about Cervantes’s captivity in Ulcinj and his
              love for a young Ulcinj lady (Dulcinea from Don Quixote got her
              name after an old name for Ulcinj), about pirates who harried both
              Montenegrin and Adriatic coast, about Jewish messiah Shabbetai
              Zevi and his last years of life spent in Old Ulcinj, about the
              famous battle near Old Bar when Montenegrins defeated the powerful
              Byzantine army, about an old olive tree which have reconciled
              local residents for millenniums and it is scientifically confirmed
              to be the oldest olive tree in Europe.
            </p>
            <p class='pasus'>
              Old town of Bar is also called Montenegrin Pompeii owing to a
              great destruction it suffered during liberation battles. Nowadays,
              the interior between his walls is not inhabited yet it represents
              an archeological gem for future explorations like the old town of
              Ulcinj with its exotic stories about pirates and slaves.
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/placestogo/04/01.jpg'),
          thumbnail: require('@/assets/placestogo/04/01.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/04/02.jpg'),
          thumbnail: require('@/assets/placestogo/04/02.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/04/03.jpg'),
          thumbnail: require('@/assets/placestogo/04/03.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/04/04.jpg'),
          thumbnail: require('@/assets/placestogo/04/04.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/04/05.jpg'),
          thumbnail: require('@/assets/placestogo/04/05.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/04/06.jpg'),
          thumbnail: require('@/assets/placestogo/04/06.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/04/07.jpg'),
          thumbnail: require('@/assets/placestogo/04/07.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/04/08.jpg'),
          thumbnail: require('@/assets/placestogo/04/08.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.pasus {
  text-align: justify;
  color: rgb(43, 42, 42);
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/PTG4_OldSouthTowns.vue